import { render } from "./Carousel.vue?vue&type=template&id=eeabb7b8&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=eeabb7b8&scoped=true&lang=css"

import exportComponent from "/Users/salome/Desktop/salomeg5/epica/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeabb7b8"]])

export default __exports__